import { BaseEntryScope } from '#packages/apilib';
import { EditorAPIKey, BreakpointsApiKey } from '#packages/apis';

export class StageContextScope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  breakpointsApi = this.useDependency(BreakpointsApiKey);
}
